import React, { useState } from "react";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

interface BaseTimePickerProps {
  initialValue?: Date;
  onChange: (e: any)=>void;
}

export default function BaseTimePicker({ initialValue, onChange }: BaseTimePickerProps) {
  const [selectedTime, setSelectedTime] = useState(initialValue);

  const setTimeSelected = (val: any)=>{
    onChange(val)
    setSelectedTime(val)
  }

  return (
    <div className="form__input--group">
      <TimePicker
        onChange={setTimeSelected}
        disableClock={true}
        format={"hh:mm a"}
        className="form__input"
        value={selectedTime}
      />
    </div>
  );
}
